import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const SolicitudesClientes = () => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Función para obtener datos de la API
  const fetchSolicitudes = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const requestData = {
        Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
        Ambiente: 'DESA',
        Dispositivo: {
          Marca: 'SAMSUNG',
          Modelo: 'S22002B',
          Version: 'Android 18.125',
          McAdress: null,
          PowerStatus: '84%',
          WifiStatus: 'Conected to iphone de Mauricio',
          GPSStatus: 'ON',
          GPS: '321|-485|321'
        },
        Usr: {
          Codigo: '',
          UserNickName: 'pierril'
        },
        DatosMetodo: {
          NombreMetodo: 'ObtenerListaSolicitudesModClientes',
          Datos_Recibidos: ''
        }
      };

      const url = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(requestData))}`;
      const response = await fetch(url);
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (!data.datos_Generados) {
        throw new Error('No se encontraron datos generados');
      }
      
      const datosGenerados = JSON.parse(data.datos_Generados);
      setSolicitudes(datosGenerados.SOLICITUDES_CAMBIOS || []);
      
    } catch (err) {
      setError(err.message);
      console.error('Error al obtener solicitudes:', err);
    } finally {
      setLoading(false);
    }
  };

  // Función para manejar acciones (aprobación/rechazo)
  const handleAccion = async (solicitud, accion) => {
    try {
      // Datos para enviar al servidor según el formato requerido
      const actionData = {
        "Token": "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
        "Ambiente": "DESA",
        "Dispositivo": {
          "Marca": "motorola",
          "Modelo": "moto g54 5G",
          "Version": "14",
          "McAdress": null,
          "PowerStatus": "84%",
          "WifiStatus": "Conected to iphone de Mauricio",
          "GPSStatus": "ON",
          "GPS": "-90.509232|14.5903641|0"
        },
        "User": {
          "Codigo": "123", // Aquí debes colocar el código real del usuario que está aprobando/rechazando
          "UserNickName": "MSILVESTRE"
        },
        "Metodo": {
          "NombreMetodo": "AprobarSolicitudesModClientes", // Según tu JSON ejemplo
          "Datos_Recibidos": JSON.stringify({
            "CodSolicitud": solicitud.Num,
            "CodUsuario": 3, // Mismo código del usuario que aprueba/rechaza
            "TipoAprov": accion === 'aprobar' ? 'A' : 'R'
          }),
          "datos_Generados": ""
        }
      };
      console.log(actionData)
      const response = await fetch('https://appcorp.parma.com.gt/API/ReceptorDatos', {
        method: 'POST', // Petición tipo POST
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(actionData)
      });
  
      const result = await response.json(); 
      console.log(result);
      alert("ACTULIZACION CORRECTA ")

    } catch (err) {
      alert(`Error: ${err.message}`);
      console.error('Error al procesar acción:', err);
    }
  };

  // Obtener datos al cargar el componente
  useEffect(() => {
    fetchSolicitudes();
  }, []);

  // Formatear fecha
  const formatFecha = (fechaISO) => {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleString('es-GT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (loading) {
    return (
      <div className="container mt-4 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
        <p>Cargando solicitudes...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger">
          <strong>Error:</strong> {error}
        </div>
        <button className="btn btn-primary" onClick={fetchSolicitudes}>
          Reintentar
        </button>
      </div>
    );
  }

  if (solicitudes.length === 0) {
    return (
      <div className="container mt-4">
        <div className="alert alert-info">
          No se encontraron solicitudes pendientes.
        </div>
        <button className="btn btn-primary" onClick={fetchSolicitudes}>
          Refrescar
        </button>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Solicitudes de Modificación de Clientes</h2> 
      <div className="mt-3">
        <button className="btn btn-primary" onClick={fetchSolicitudes}>
          Actualizar Listado
        </button>
      </div> 
      <br />
      
      <div className="table-responsive">
        <table className="table table-striped table-bordered table-hover">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Solicitante</th>
              <th>Tipo</th>
              <th>Fecha</th>
              <th>Estado</th>
              <th>Cliente</th>
              <th>Datos a Modificar</th>
              <th>Geocerca</th>
              <th>Territorio</th>
              <th>Autorizador</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {solicitudes.map((solicitud) => (
              <tr key={solicitud.Num} className={solicitud.Estado === 'Aprobado' ? 'table-success' : solicitud.Estado === 'Rechazado' ? 'table-danger' : ''}>
                <td>{solicitud.Num}</td>
                <td>{solicitud.Solicitante}</td>
                <td>{solicitud.Tipo}</td>
                <td>{formatFecha(solicitud.Fecha)}</td>
                <td>{solicitud.Estado}</td>
                <td>{solicitud.Cliente}</td>
                <td>{solicitud.Datos_Mod}</td>
                <td>{solicitud.Geocerca}</td>
                <td>{solicitud.Territorio}</td> 
                <td>{solicitud.Autorizador}</td>   
                <td>
                  {solicitud.Estado === 'Ingresado' && (
                    <>
                      <button 
                        className="btn btn-success btn-sm mx-1"
                        onClick={() => handleAccion(solicitud, 'aprobar')}
                        title="Aprobar"
                      >
                        ✓ Aprobar
                      </button>
                      <button 
                        className="btn btn-danger btn-sm mx-1"
                        onClick={() => handleAccion(solicitud, 'rechazar')}
                        title="Rechazar"
                      >
                        ✕ Rechazar
                      </button>
                    </>
                  )}
                  {solicitud.Estado !== 'Ingresado' && (
                    <span className="text-muted">Procesada</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
     
    </div>
  );
};

export default SolicitudesClientes;